import React from 'react'
import { Box, Button } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import useModals from 'src/Hooks/useModals'
import { HardwareTestResultModel } from 'src/Libs/installation-details/models'

const useStyles = makeStyles()(theme => ({
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
    gap: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.shades.shade03}`,
  },
}))

interface Props {
  testResultData: HardwareTestResultModel | undefined
  finishTest: () => void
}

/**
 * Control buttons to cancel or finish the test
 */
const ControlButtons: React.FC<Props> = ({ testResultData, finishTest }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const { openConfirmationModal } = useModals()
  const state = testResultData?.state
  const availableTests = testResultData?.availableTests

  const handleCancelTest = (): void => {
    openConfirmationModal({
      buttonText: [t('system-details.hardware-test.do-not-cancel'), t('system-details.hardware-test.confirm-cancel-button')],
      onConfirm: onClose => {
        finishTest()
        onClose()
      },
      text: t('system-details.hardware-test.cancel-test-text'),
      title: t('system-details.hardware-test.cancel-test-title'),
    })
  }

  return (
    <Box className={classes.container}>
      {!!state && !availableTests?.length ? (
        <Button onClick={finishTest} variant="contained">
          {t('system-details.hardware-test.finish-test')}
        </Button>
      ) : (
        <Button onClick={handleCancelTest}>{t('system-details.hardware-test.cancel-button')}</Button>
      )}
    </Box>
  )
}

export default ControlButtons
